import { gsap } from 'gsap';
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { SplitText } from "gsap/SplitText";
gsap.registerPlugin(SplitText);
gsap.registerPlugin(ScrollTrigger);

const initGSAPElevatorLetters = () => {

	const root = document.querySelector('.hoffman-elevator-letters');
	if (!root) return;

	const sentence01 = root.querySelector('.sentence-01');
	const sentence02 = root.querySelector('.sentence-02');
	const split01 = SplitText.create(sentence01, { type: "words,chars" });
	const split02 = SplitText.create(sentence02, { type: "words,chars" });

	const charCount = Math.max(split01.chars.length, split02.chars.length);
	const shuffleChar = [...Array(charCount).keys()].sort(() => Math.random() - 0.5);
	const stagger = (index) => shuffleChar[Math.min(index, charCount - 1)] * 0.07;

	gsap.set(split02.chars, { yPercent: 130 });

	const tl = gsap.timeline({
		scrollTrigger: {
			trigger: '.hoffman-elevator-letters',
			start: "top top",
			end: "bottom top",
			scrub: 2,
			pin:true,
		}
	});
	tl.to(split01.chars, {
		yPercent: -130,
		stagger: stagger,
		ease: "power2.out",
	}) 
	.to(split02.chars, {
		yPercent: 0,
		stagger: stagger,
		ease: "power2.out",
	}, "<");

}
export { initGSAPElevatorLetters };